export default __webpack_public_path__ + "static/singing-3aa72ac77b2310799c63e16e538d41d2.jpeg";